import { ref } from 'vue';

const DEFAULT_CARD_HOVER_TRANSFORM = 'scale(1)';

function getRandomCardHoverTransform() {
    const randomRotation = Math.random() * 4 - 2;
    const randomScale = Math.random() * (1.125 - 1.025) + 1.025;

    return `rotate(${randomRotation}deg) scale(${randomScale})`;
}

export function useRandomCardHover() {
    const hoverTransform = ref(DEFAULT_CARD_HOVER_TRANSFORM);

    function applyRandomCardHover() {
        hoverTransform.value = getRandomCardHoverTransform();
    }

    function resetRandomCardHover() {
        hoverTransform.value = DEFAULT_CARD_HOVER_TRANSFORM;
    }

    return {
        hoverTransform,
        applyRandomCardHover,
        resetRandomCardHover
    };
}
